import { Linkedin, Instagram } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import finbeamWordmark from "@/assets/finbeam-wordmark.png";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const scrollToWaitlist = () => {
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      setTimeout(() => document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' }), 100);
    } else {
      document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      setTimeout(() => document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' }), 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-ink-900 text-white/80 py-16 border-t border-white/[0.06]">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <Link to="/" className="inline-flex items-center leading-none mb-4" aria-label="finbeam">
              <img src={finbeamWordmark} alt="finbeam" className="h-10 w-auto" />
            </Link>
            <p className="text-white/60 mb-6 max-w-md text-sm leading-relaxed">{t("footer.desc")}</p>
            <div className="flex space-x-3 mb-6">
              <a href="https://www.instagram.com/finbeam.ch/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-ink-700 border border-white/10 flex items-center justify-center text-white/70 hover:text-violet hover:border-violet/40 transition-colors">
                <Instagram size={18} />
              </a>
              <a href="https://www.linkedin.com/company/finbeam/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-ink-700 border border-white/10 flex items-center justify-center text-white/70 hover:text-violet hover:border-violet/40 transition-colors">
                <Linkedin size={18} />
              </a>
            </div>
            <Link to="/partner">
              <Button className="btn-ghost-light">{t("footer.partner")}</Button>
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="eyebrow mb-4">{t("footer.product")}</h4>
              <ul className="space-y-2.5 text-sm">
                <li><button onClick={() => scrollToSection('features')} className="text-white/65 hover:text-white transition-colors text-left">{t("nav.features")}</button></li>
                <li><button onClick={() => scrollToSection('preview')} className="text-white/65 hover:text-white transition-colors text-left">{t("nav.appPreview")}</button></li>
                <li><button onClick={scrollToWaitlist} className="text-white/65 hover:text-white transition-colors text-left">{t("nav.waitlist")}</button></li>
              </ul>
            </div>
            <div>
              <h4 className="eyebrow mb-4">{t("footer.legal")}</h4>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/datenschutz" className="text-white/65 hover:text-white transition-colors">{t("footer.datenschutz")}</Link></li>
                <li><Link to="/agb" className="text-white/65 hover:text-white transition-colors">{t("footer.agb")}</Link></li>
                <li><Link to="/impressum" className="text-white/65 hover:text-white transition-colors">{t("footer.impressum")}</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-white/[0.06] mt-12 pt-8 text-center text-white/55 text-xs">
          <p>{t("footer.copyright")}</p>
          <p className="mt-2">{t("footer.madeWith")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
